import { Box, Tab } from "@material-ui/core";
import { TabContext, TabList, TabPanel } from '@material-ui/lab';
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store";
import { setCurrentTabPrograma } from "store/modules/EscolasActions";
import './index.scss'
import { TipoPrograma } from "../../__enum";
import { CooperativaEscolar, FinancasNaMochila, UniaoFazAVida } from "../../listaPrograma";
interface TabProgramaProps {
  programasVisiveis: TipoPrograma[];
}

const TabPrograma = ({ programasVisiveis }: TabProgramaProps) => {
  const dispatch = useDispatch();
  const currentTab = useSelector((state: RootState) => state.escolas.programaTabCurrent);

  const validTab = programasVisiveis.includes(currentTab as TipoPrograma)
    ? (currentTab as TipoPrograma)
    : programasVisiveis[0] || '';

  const getLabel = (key: string) => {
    switch (key) {
      case TipoPrograma.UniaoFazAVida: return 'A União Faz a Vida';
      case TipoPrograma.CooperativaEscolar: return 'Cooperativas Escolares';
      case TipoPrograma.FinancasNaMochila: return 'Finanças na Mochila';
      default: return 'Programa inválido';
    }
  };

  const renderTabContent = (key: string) => {
    switch (key) {
      case TipoPrograma.UniaoFazAVida: return <UniaoFazAVida />;
      case TipoPrograma.CooperativaEscolar: return <CooperativaEscolar />;
      case TipoPrograma.FinancasNaMochila: return <FinancasNaMochila />;
      default: return null;
    }
  };

  if (programasVisiveis.length === 0) return null;

  return (
    <Box className="tab__container">
      <TabContext value={validTab}>
        <TabList
          centered
          variant="fullWidth"
          onChange={(e, newValue) => dispatch(setCurrentTabPrograma(newValue))}
          TabIndicatorProps={{
            style: {
              backgroundColor: '#3FA110',
            }
          }}
        >
          {programasVisiveis.map((key) => (
            <Tab
              key={key}
              value={key}
              label={getLabel(key)}
              style={{ flex: 'auto', textTransform: 'none', color: '#3FA110' }}
            />
          ))}
        </TabList>
        <Box>
          {programasVisiveis.map((key) => (
            <TabPanel className="tab_container-render" key={key} value={key}>
              {renderTabContent(key)}
            </TabPanel>
          ))}
        </Box>
      </TabContext>
    </Box >
  );
};

export default TabPrograma;